var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',{attrs:{"length":_vm.pageLength,"total-visible":6},model:{value:(_vm.m_page),callback:function ($$v) {_vm.m_page=$$v},expression:"m_page"}})}
var staticRenderFns = []

export { render, staticRenderFns }